import { useState } from 'react';
import { KeyRound, User, Ticket } from "lucide-react";
import "./assets/auth/login.css";
import { useSession } from './assets/auth/SessionContext';

export default function Login() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const { login, error } = useSession();

    function handleKeyUp(event: any) {
        if (username && password && event.keyCode === 13) {
            login({ username, password });
        }
    }

    return (
        <form onKeyUp={handleKeyUp}>
            <div className="login-page">

                {/* Left brand panel */}
                <div className="login-left">
                    <div className="login-brand">
                        <div className="login-brand-logo">
                            <Ticket size={40} color="#fff" />
                        </div>
                        <div className="login-brand-title">TDI Ticketing</div>
                        <div className="login-brand-subtitle">
                            Back Office Management Platform
                        </div>
                    </div>
                    <div className="login-left-circle" />
                </div>

                {/* Right form panel */}
                <div className="login-right">
                    <div className="login-container">
                        <div className="header">
                            <div className="text">Sign in</div>
                            <div className="underline"></div>
                        </div>

                        <div className="inputs">
                            <div className="input">
                                <div className="icon-image">
                                    <User size={20} />
                                </div>
                                <input
                                    type="text"
                                    placeholder="Username"
                                    onChange={(e) => setUsername(e.target.value)}
                                />
                            </div>
                            <div className="input">
                                <div className="icon-image">
                                    <KeyRound size={20} />
                                </div>
                                <input
                                    type="password"
                                    placeholder="Password"
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                            </div>
                        </div>

                        <div className="submit-container">
                            <div
                                className="submit"
                                onClick={() => login({ username, password })}
                            >
                                Login
                            </div>
                        </div>

                        <div className="error-handling">
                            <span>{error}</span>
                        </div>
                    </div>
                </div>

            </div>
        </form>
    );
}
